import script from "./UOrgInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UOrgInfo.vue?vue&type=script&setup=true&lang=ts"

import "./UOrgInfo.vue?vue&type=style&index=0&id=11be5286&lang=css"

const __exports__ = script;

export default __exports__